(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-evidence-product-evidence-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-f2-product-evidence-product-evidence-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-product-evidence-product-evidence-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-f2-product-evidence-product-evidence-domain'.");
    }
    root['boislocal-platform-platform-f2-product-evidence-product-evidence-domain'] = factory(typeof this['boislocal-platform-platform-f2-product-evidence-product-evidence-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-f2-product-evidence-product-evidence-domain'], this['kotlin-kotlin-stdlib'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var defineProp = kotlin_kotlin.$_$.b9;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRoles = kotlin_org_boislocal_commons_domain.$_$.l;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ProductEvidenceDeleteCommandDTO, 'ProductEvidenceDeleteCommandDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceDeletedEventDTO, 'ProductEvidenceDeletedEventDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceUploadCommandDTO, 'ProductEvidenceUploadCommandDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceUploadedEventDTO, 'ProductEvidenceUploadedEventDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceFileDTO, 'ProductEvidenceFileDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceSectionDTO, 'ProductEvidenceSectionDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceSectionValues, 'ProductEvidenceSectionValues', objectMeta);
  setMetadataFor(ProductEvidencePolicies, 'ProductEvidencePolicies', objectMeta);
  setMetadataFor(ProductEvidenceDownloadQueryDTO, 'ProductEvidenceDownloadQueryDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceListQueryDTO, 'ProductEvidenceListQueryDTO', interfaceMeta);
  setMetadataFor(ProductEvidenceListResultDTO, 'ProductEvidenceListResultDTO', interfaceMeta);
  //endregion
  function ProductEvidenceDeleteCommandDTO() {
  }
  function ProductEvidenceDeletedEventDTO() {
  }
  function ProductEvidenceUploadCommandDTO() {
  }
  function ProductEvidenceUploadedEventDTO() {
  }
  function ProductEvidenceFileDTO() {
  }
  function ProductEvidenceSectionDTO() {
  }
  function ProductEvidenceSectionValues() {
  }
  protoOf(ProductEvidenceSectionValues).from = function () {
    return 'FROM';
  };
  protoOf(ProductEvidenceSectionValues).to = function () {
    return 'TO';
  };
  var ProductEvidenceSectionValues_instance;
  function ProductEvidenceSectionValues_getInstance() {
    return ProductEvidenceSectionValues_instance;
  }
  function isMarqueOrTransformationActorOrAdmin(_this__u8e3s4, $this, product) {
    var tmp;
    if (hasRoles(_this__u8e3s4, ['Marque', 'admin'])) {
      tmp = true;
    } else {
      tmp = isTransformationActor(_this__u8e3s4, $this, product);
    }
    return tmp;
  }
  function isTransformationActorOrAdmin(_this__u8e3s4, $this, product) {
    var tmp;
    if (hasRoles(_this__u8e3s4, ['admin'])) {
      tmp = true;
    } else {
      tmp = isTransformationActor(_this__u8e3s4, $this, product);
    }
    return tmp;
  }
  function isTransformationActor(_this__u8e3s4, $this, product) {
    var tmp;
    var tmp1_safe_receiver = product == null ? null : product.transformation;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.actor;
    if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.id) == _this__u8e3s4.memberOf) {
      tmp = !(_this__u8e3s4.memberOf == null);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function ProductEvidencePolicies() {
  }
  protoOf(ProductEvidencePolicies).canList = function (authedUser, product) {
    return isMarqueOrTransformationActorOrAdmin(authedUser, this, product);
  };
  protoOf(ProductEvidencePolicies).canDownload = function (authedUser, product) {
    return isMarqueOrTransformationActorOrAdmin(authedUser, this, product);
  };
  protoOf(ProductEvidencePolicies).canUpload = function (authedUser, product) {
    return isTransformationActorOrAdmin(authedUser, this, product);
  };
  protoOf(ProductEvidencePolicies).canDelete = function (authedUser, product) {
    return isTransformationActorOrAdmin(authedUser, this, product);
  };
  var ProductEvidencePolicies_instance;
  function ProductEvidencePolicies_getInstance() {
    return ProductEvidencePolicies_instance;
  }
  function ProductEvidenceDownloadQueryDTO() {
  }
  function ProductEvidenceListQueryDTO() {
  }
  function ProductEvidenceListResultDTO() {
  }
  //region block: init
  ProductEvidenceSectionValues_instance = new ProductEvidenceSectionValues();
  ProductEvidencePolicies_instance = new ProductEvidencePolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$evidence = $org$boislocal$platform$f2$product.evidence || ($org$boislocal$platform$f2$product.evidence = {});
    var $org$boislocal$platform$f2$product$evidence$domain = $org$boislocal$platform$f2$product$evidence.domain || ($org$boislocal$platform$f2$product$evidence.domain = {});
    var $org$boislocal$platform$f2$product$evidence$domain$command = $org$boislocal$platform$f2$product$evidence$domain.command || ($org$boislocal$platform$f2$product$evidence$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$evidence = $org$boislocal$platform$f2$product.evidence || ($org$boislocal$platform$f2$product.evidence = {});
    var $org$boislocal$platform$f2$product$evidence$domain = $org$boislocal$platform$f2$product$evidence.domain || ($org$boislocal$platform$f2$product$evidence.domain = {});
    var $org$boislocal$platform$f2$product$evidence$domain$command = $org$boislocal$platform$f2$product$evidence$domain.command || ($org$boislocal$platform$f2$product$evidence$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$evidence = $org$boislocal$platform$f2$product.evidence || ($org$boislocal$platform$f2$product.evidence = {});
    var $org$boislocal$platform$f2$product$evidence$domain = $org$boislocal$platform$f2$product$evidence.domain || ($org$boislocal$platform$f2$product$evidence.domain = {});
    var $org$boislocal$platform$f2$product$evidence$domain$model = $org$boislocal$platform$f2$product$evidence$domain.model || ($org$boislocal$platform$f2$product$evidence$domain.model = {});
    defineProp($org$boislocal$platform$f2$product$evidence$domain$model, 'ProductEvidenceSectionValues', ProductEvidenceSectionValues_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$evidence = $org$boislocal$platform$f2$product.evidence || ($org$boislocal$platform$f2$product.evidence = {});
    var $org$boislocal$platform$f2$product$evidence$domain = $org$boislocal$platform$f2$product$evidence.domain || ($org$boislocal$platform$f2$product$evidence.domain = {});
    var $org$boislocal$platform$f2$product$evidence$domain$policy = $org$boislocal$platform$f2$product$evidence$domain.policy || ($org$boislocal$platform$f2$product$evidence$domain.policy = {});
    defineProp($org$boislocal$platform$f2$product$evidence$domain$policy, 'ProductEvidencePolicies', ProductEvidencePolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$evidence = $org$boislocal$platform$f2$product.evidence || ($org$boislocal$platform$f2$product.evidence = {});
    var $org$boislocal$platform$f2$product$evidence$domain = $org$boislocal$platform$f2$product$evidence.domain || ($org$boislocal$platform$f2$product$evidence.domain = {});
    var $org$boislocal$platform$f2$product$evidence$domain$query = $org$boislocal$platform$f2$product$evidence$domain.query || ($org$boislocal$platform$f2$product$evidence$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$product = $org$boislocal$platform$f2.product || ($org$boislocal$platform$f2.product = {});
    var $org$boislocal$platform$f2$product$evidence = $org$boislocal$platform$f2$product.evidence || ($org$boislocal$platform$f2$product.evidence = {});
    var $org$boislocal$platform$f2$product$evidence$domain = $org$boislocal$platform$f2$product$evidence.domain || ($org$boislocal$platform$f2$product$evidence.domain = {});
    var $org$boislocal$platform$f2$product$evidence$domain$query = $org$boislocal$platform$f2$product$evidence$domain.query || ($org$boislocal$platform$f2$product$evidence$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-f2-product-evidence-product-evidence-domain.js.map
